import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Avatar,
  Box,
  Tooltip,
  Divider,
  Typography,
} from "@mui/material";

import {
  ExpandLess,
  ExpandMore,
  Home,
  Business,
  Store,
  People,
  Security,
  BarChart,
  PeopleOutline,
  PeopleTwoTone,
  Diversity3,
  PinDrop,
  Source,
  AccountBalance,
  LocalShipping,
  AdminPanelSettings,
  Article,
} from "@mui/icons-material";
import { NavLink } from "react-router-dom";
// App Icons
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SecurityIcon from '@mui/icons-material/Security';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddModeratorTwoToneIcon from '@mui/icons-material/AddModeratorTwoTone';
import SyncIcon from '@mui/icons-material/Sync';
//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

const Sidebar = ({ open }) => {
  const [masterOpen, setMasterOpen] = useState(false);
  const [tranascationOpen, setTransactionOpen] = useState(false);
  const [accountsOpen, setAccountsOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const [subMenuOpen, setSubMenuOpen] = useState({
    purchase: false,
    sale: false,
    stocks: false,
    Accounts: false,
  });

  const toggleSubMenu = (menu) => {
    setSubMenuOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
  const { companyName, companyId, isSuperAdmin, superCompanyId, permissions, roleName } = useAuth();

  {/* Permissions */ }
  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadTransactionPermission = permissions.includes('Read Transaction');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReadReportsPermission = permissions.includes('Read Reports');

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: open ? 240 : 60,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? 240 : 60,
          // background: "linear-gradient(180deg, #173B45 0%, #173B45 100%)",
          background: "linear-gradient(180deg, #34332f 0%, #34332f 100%)",
          color: "white",
          overflowX: "hidden",
          transition: "width 0.3s",
          borderRight: "none",
        },
      }}
    >
      {/* Profile */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
          justifyContent: open ? "flex-start" : "center",
        }}
      >
        {open && (
          <Box>

          </Box>
        )}
      </Box>
      <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />

      <List style={{ paddingLeft: '10px', fontFamily: 'monospace', marginTop: '25px' }}>

        <ListItem button component={NavLink} to="/CompanyEdit" activeClassName="selected" style={{ height: '40px' }}>
          <BusinessIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Company"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem button component={NavLink} to="/CustomerIndex" activeClassName="selected" style={{ height: '40px' }}>
          <PersonIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Customer"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>
        <ListItem button component={NavLink} to="/WorkIndex" activeClassName="selected" style={{ height: '40px' }}>
          <ListAltIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Work"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem button component={NavLink} to="/WorkDetailsIndex" activeClassName="selected" style={{ height: '40px' }}>
          <CategoryIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Work Details"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem
          button
          component={NavLink}
          to="/QuotationIndex"
          activeClassName="selected"
          style={{ height: '40px' }}
        >
          <DescriptionIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Quotation"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem
          button
          component={NavLink}
          to="/RevisionQuotationIndex"
          activeClassName="selected"
          style={{ height: '40px' }}
        >
          <SyncIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Revision List"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem
          button
          component={NavLink}
          to="/InvoiceIndex"
          activeClassName="selected"
          style={{ height: '40px' }}
        >
          <ReceiptLongIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Invoice"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem button component={NavLink} to="/TermsAndConditions" activeClassName="selected" style={{ height: '40px' }}>
          <AddModeratorTwoToneIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Terms & Conditions"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
                fontSize: '14.5px'
              },
            }}
          />
        </ListItem>

        <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" style={{ height: '40px' }}>
          <PeopleAltIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="User"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>

        <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" style={{ height: '40px' }}>
          <SecurityIcon style={{ color: 'white', height: '20px' }} />
          <ListItemText
            primary="Change Password"
            primaryTypographyProps={{
              style: {
                marginLeft: '10px',
                color: 'white',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>
      </List>

    </Drawer>

  );
};

export default Sidebar;
